import React, { useContext } from "react";
import Confirmation from "./Confirmation";
import Form from "./Form";
import Message from "./Message";
import Start from "./Start";
import { SubscriptionContext } from "../..";

const Application = () => {
  const { form = {}, pendingApplication } = useContext(SubscriptionContext);
  const { started } = form;

  return (
    <>
      {pendingApplication ? (
        <Confirmation />
      ) : (
        <>
          <Message />
          {started ? <Form /> : <Start />}
        </>
      )}
    </>
  );
};

export default Application;
